(() => {
  function init(root) {
    if (!root || root.dataset.ecoReady || !root.querySelector('[data-eco-setup]')) return;
    root.dataset.ecoReady = 'true';
    const buttons = [...root.querySelectorAll('[data-eco-filter]')];
    const cards = [...root.querySelectorAll('[data-eco-group]')];
    const select = root.querySelector('[data-eco-setup]');
    let group = '48';
    const setupCopy = {
      stock: 'OEM stock-cart estimate: non-lifted, 2 passengers, stock gearing, flat terrain, controller up to 350A.',
      modified: 'OEM modified-cart estimate: 4 passengers, lifted with tires up to 23 inches, stock gearing, moderate terrain, controller up to 450A. Higher capacity is suggested for the 60Ah pack; a 48V conversion is recommended for the 38.4V application.',
      heavy: 'OEM heavily modified estimate: 4–6 passengers, tires up to 23 inches, high-speed gears, steep terrain, controller up to 600A. Higher capacity is suggested for 105Ah 51.2V packs. 38.4V and 60Ah packs are not recommended. Controller ratings are not battery continuous-current ratings.'
    };
    const labels = {stock: 'stock setup', modified: 'modified setup', heavy: 'heavily modified setup'};
    function update() {
      let visible = 0;
      cards.forEach(card => {
        card.hidden = group !== 'all' && card.dataset.ecoGroup !== group;
        if (!card.hidden) visible++;
        card.querySelector('[data-eco-range]').textContent = card.dataset['eco' + select.value[0].toUpperCase() + select.value.slice(1)];
        card.querySelector('[data-eco-range-label]').textContent = labels[select.value];
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ecoFilter === group)));
      const cta = root.querySelector('[data-eco-cta]');
      if (cta) cta.dataset.ecoCount = String(visible);
      root.querySelector('[data-eco-setup-note]').textContent = setupCopy[select.value];
      root.querySelector('[data-eco-results]').textContent = `${visible} battery ${visible === 1 ? 'option' : 'options'} shown. Cart Mart confirms compatibility before installation.`;
    }
    buttons.forEach(button => button.addEventListener('click', () => {group = button.dataset.ecoFilter; update();}));
    select.addEventListener('change', update);
    update();
  }
  document.querySelectorAll('.cm-eco').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.cm-eco').forEach(init));
})();

